import { render, staticRenderFns } from "./CantTransactions.vue?vue&type=template&id=51ee17a8"
import script from "./CantTransactions.vue?vue&type=script&lang=js"
export * from "./CantTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports